import Vue from 'vue'
import App from './App.vue'
// import { Icon, Form, Button, RadioGroup, Radio, Field, Cell, Toast, Dialog, Picker, Popup, Overlay, Grid, GridItem, Image as VanImage } from 'vant'
//
// Vue.use(Icon)
// Vue.use(Form)
// Vue.use(Button)
// Vue.use(RadioGroup)
// Vue.use(Radio)
// Vue.use(Field)
// Vue.use(Cell)
// Vue.use(Toast)
// Vue.use(Dialog)
// Vue.use(Picker)
// Vue.use(Popup)
// Vue.use(Overlay)
// Vue.use(Grid)
// Vue.use(GridItem)
// Vue.use(VanImage)

// import { Button, Input, Icon } from 'element-ui';
// Vue.use(Button)
// Vue.use(Input)
// Vue.use(Icon)

import { Toast, Button } from 'vant'
Vue.use(Toast)
Vue.use(Button)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']

new Vue({
  render: h => h(App),
}).$mount('#app')
